export function httpGet (url, params) {
  return new Promise((resolve, reject) => {
    window.Vue.http.get(
      url,
      {
        params
      },
      {emulateJSON: false}
    )
    .then((res) => {
      let body = res.body
      if (body.status === 'success') {
        console.log(body)
        resolve(body.data)
      } else {
        reject(body.msg)
      }
    })
    .catch((res) => {
      let body = res.body
      console.log(body.error)
      reject(body.msg)
    })
  })
}

export function httpPost (url, params) {
  return new Promise((resolve, reject) => {
    window.Vue.http.post(
      url,
      params,
      {emulateJSON: false}
    )
    .then((res) => {
      let body = res.body
      if (body.status === 'success') {
        resolve(body.data)
      } else {
        reject(body.msg)
      }
    })
    .catch((res) => {
      console.log(res)
      let body = res.body
      reject(body.msg)
    })
  })
}

export const baseUrl = 'https://open.api.qooco.com/ReportingAPI/'
// export const baseUrl = 'http://127.0.0.1:9999/ReportingAPI/'



// WEBPACK FOOTER //
// ./src/api/base.js